import { createCache, PetShop } from 'pet-shop';

const namespace = `xinxiangsui-${import.meta.env.CONFIG_NAME}`;

export const localStore = PetShop({
  namespace,
  storage: localStorage,
  json: true,
});

export const sessionStore = PetShop({
  namespace,
  storage: sessionStorage,
  json: true,
});

export const Auth = createCache(sessionStore, [
  'token',
  'tenant',
  'code',
  'info',
]);

export const Experiments = createCache(localStore, ['useMiniApp']);

export const Temp = createCache(sessionStore, ['loop', 'deviceId']);

if (import.meta.env.WATCHING) {
  Auth.token = '9a36a593-31f0-11f0-ae6e-c36dbe07a652';
}
